import React, { useEffect } from "react";
import { SkipToContent } from "@/components/site/SkipToContent";
import { StickyHeader } from "@/components/site/StickyHeader";
import { HeroV2 } from "@/components/site/v2/HeroV2";
import { AnimatedStats } from "@/components/site/v2/AnimatedStats";
import { OfferingsV4 } from "@/components/site/v4/OfferingsV4";
import { AboutV2 } from "@/components/site/v2/AboutV2";
import { EventsV2 } from "@/components/site/v2/EventsV2";
import { ProgramsV4 } from "@/components/site/v4/ProgramsV4";
import { PhaseImmersive } from "@/components/site/PhaseImmersive";
import { GalleryV4 } from "@/components/site/v4/GalleryV4";
import { NewsV4 } from "@/components/site/v4/NewsV4";
import { FinalCTAV4 } from "@/components/site/v4/FinalCTAV4";
import { SiteFooter } from "@/components/site/SiteFooter";
import { scrollToId } from "@/lib/scrollTo";

/**
 * HomeFinal — the client-approved combined homepage.
 * Section order & source design:
 *  1. Hero .................. Immersive (HeroV2, shortened scroll)
 *  2. Impact ................ Immersive (AnimatedStats)
 *  3. Explore ............... Fresh (OfferingsV4)
 *  4. Who we are ............ Immersive (AboutV2)
 *  5. Featured Event ........ Immersive (EventsV2)
 *  6. Our Program ........... Fresh (ProgramsV4, Flats only)
 *  7. Phase ................. Immersive (PhaseImmersive, 5-col grid)
 *  8. Gallery ............... Fresh (GalleryV4)
 *  9. Announcements & Stories Fresh (NewsV4)
 * 10. Join Community ........ Fresh (FinalCTAV4)
 */
export default function HomeFinal() {
  useEffect(() => {
    // Honor a #section hash when arriving from another page (e.g. /history),
    // otherwise start at the top.
    const hash = typeof window !== "undefined" ? window.location.hash.slice(1) : "";
    if (hash && document.getElementById(hash)) {
      const t = window.setTimeout(() => scrollToId(hash), 120);
      return () => window.clearTimeout(t);
    }
    window.scrollTo(0, 0);
  }, []);
  return (
    <>
      <SkipToContent />
      <StickyHeader overlay />
      <main id="content" tabIndex={-1} className="outline-none">
        <HeroV2 scrollVh={140} />
        <AnimatedStats />
        <OfferingsV4 overlap={false} />
        <AboutV2 />
        <EventsV2 />
        <ProgramsV4 showMentorship={false} />
        <PhaseImmersive />
        <GalleryV4 />
        <NewsV4 />
        <FinalCTAV4 />
      </main>
      <SiteFooter />
    </>
  );
}
